import adFinanceResource from './resource';
import errorTransformer from '../shared/transformers/errorTransformer';

/**
 * It fetches redirectURL of the bank
 * @param {number} amount - Amount of the money
 * @returns {Promise<redirectUrl>}
 */
function getPaymentURL(amount) {
  return adFinanceResource
    .getPaymentURL({
      amount,
      gatewayCode: '_shetab',
    })
    .then(
      ({
        body: {
          extra: { redirectUrl },
        },
      }) => {
        return redirectUrl;
      },
    )
    .catch(errorTransformer);
}

function downloadInvoiceFactor(id) {
  return adFinanceResource
    .downloadInvoiceFactor({ itemId: id })
    .then(res => res.blob())
    .catch(errorTransformer);
}

function downloadTransactionInvoiceFactor(id) {
  return adFinanceResource
    .downloadTransactionInvoiceFactor({ itemId: id })
    .then(res => res.blob())
    .catch(errorTransformer);
}

export default {
  getPaymentURL,
  downloadInvoiceFactor,
  downloadTransactionInvoiceFactor,
};
